import TopdataLlmConnectApiService from '../service/topdata-llm-connect-api.service';

Shopware.Service().register('topdataLlmConnectApiService', (container) => {
    const initContainer = Shopware.Application.getContainer('init');

    return new TopdataLlmConnectApiService(initContainer.httpClient, container.loginService);
});
